import React from 'react';

import { Text } from 'farmhub-ui-core';

import { Wrapper } from './styles';

type TypeBillingItemProps = {
  icon: React.ReactNode;
  title: string;
  selected: boolean;
};

const TypeBillingItem = ({ icon, title, selected }: TypeBillingItemProps) => (
  <Wrapper selected={selected}>
    {icon}
    <Text
      color={selected ? 'main' : 'secondary'}
      styles={{ display: 'block', textAlign: 'center' }}
      weight="medium"
    >
      {title}
    </Text>
  </Wrapper>
);

export default TypeBillingItem;
